
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"75","height":"75","viewBox":"0 0 75 75","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"75","height":"75","rx":"10","fill":"#A5D8FF"}}),_c('path',{attrs:{"d":"M37.4842 10C22.3047 10 10 22.3118 10 37.5C10 52.6882 22.3047 65 37.4842 65C51.4462 65 63.1655 54.528 64.798 40.767C64.9739 39.2572 63.8993 37.852 62.3904 37.6705C60.8842 37.4945 59.4771 38.5697 59.3012 40.0795C57.9957 51.0795 48.6538 59.5 37.4842 59.5C25.3417 59.5 15.4968 49.6495 15.4968 37.5C15.4968 25.3505 25.3417 15.5 37.4842 15.5C40.021 15.5 42.5331 15.9592 44.872 16.7897C46.3011 17.2957 47.799 16.501 48.3075 15.071C48.8132 13.6382 48.1041 12.0543 46.6749 11.5455C43.7506 10.5088 40.6476 10 37.4842 10ZM62.22 15.5C61.5164 15.5 60.7798 15.7475 60.2439 16.2728L36.2804 39.9062C35.574 40.602 34.8622 40.4673 34.307 39.6478L31.5586 35.608C30.7176 34.3678 28.9531 34.0075 27.6943 34.8353C26.4328 35.663 26.0783 37.3763 26.9193 38.6165L29.6677 42.6562C32.144 46.311 36.9895 46.795 40.1474 43.6875L64.1961 20.142C65.268 19.086 65.268 17.3288 64.1961 16.2728C63.6601 15.7448 62.9236 15.5 62.22 15.5Z","fill":"white"}})])
          )
        }
      }
    